import React, {useState, useRef, useEffect} from 'react';
import "./styles.sass";
import {useField} from "@unform/core";

const AutoComplete = ({suggestions, name, label, onSelect, ...rest}) => {

    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [input, setInput] = useState("");
    const inputRef = useRef(null)
    const {fieldName, defaultValue, registerField, error} = useField(name);

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: inputRef,
            getValue: ref => {
                return ref.current.value;
            },
            setValue: (ref, value) => {
                ref.current.value = value || '';
            },
            clearValue: ref => {
                ref.current.value = ''
            },
        })
    }, [fieldName, registerField])

    const onChange = (e) => {
        const userInput = e.target.value;

        const unLinked = suggestions.filter(
            (suggestion) =>
                suggestion[label].toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );

        setInput(e.target.value);
        setFilteredSuggestions(unLinked);
        setActiveSuggestionIndex(0);
        setShowSuggestions(true);
    };

    const onClick = (e) => {
        setFilteredSuggestions([]);
        setInput(e.target.innerText);
        setActiveSuggestionIndex(0);
        setShowSuggestions(false);

        if(onSelect){
            onSelect(e.target.innerText);
        }
    };

    const onKeyDown = (e) => {
        // User pressed the enter key
        if (e.keyCode === 13) {
            setInput(filteredSuggestions[activeSuggestionIndex]);
            setActiveSuggestionIndex(0);
            setShowSuggestions(false);
        }
        // User pressed the up arrow
        else if (e.keyCode === 38) {
            if (activeSuggestionIndex === 0) {
                return;
            }

            setActiveSuggestionIndex(activeSuggestionIndex - 1);
        }
        // User pressed the down arrow
        else if (e.keyCode === 40) {
            if (activeSuggestionIndex - 1 === filteredSuggestions.length) {
                return;
            }

            setActiveSuggestionIndex(activeSuggestionIndex + 1);
        }
    };

    const SuggestionsListComponent = () => {
        return filteredSuggestions.length ? (
            <ul className="list-group mt-2">
                {filteredSuggestions.map((suggestion, index) => {
                    let className;

                    if (index === activeSuggestionIndex) {
                        className = "suggestion-active";
                    }

                    return (
                        <li className={`list-group-item ${className}`} key={suggestion[label]} onClick={onClick}>
                            {suggestion[label]}
                        </li>
                    );
                })}
            </ul>
        ) : (
            <div className="no-suggestions">
                <span role="img" aria-label="tear emoji">
                  😪
                </span>{" "}
                <em>sorry no suggestions</em>
            </div>
        );
    };

    return (
        <>
            <input
                ref={inputRef}
                defaultValue={defaultValue}
                type="text"
                className={'form-control'}
                onChange={onChange}
                onKeyDown={onKeyDown}
                value={input}
                {...rest}
            />
            {showSuggestions && input && <SuggestionsListComponent/>}
            {error && <span className="error">{error}</span>}
        </>
    );
};

export default AutoComplete;
